import React from 'react';

/** Renders **bold** and `code` spans in answer text (line breaks come from pre-wrap on the parent). */
export function renderInlineMarkdown(text, theme) {
  if (text == null || text === '') return null;

  const parts = [];
  const pattern = /(\*\*[^*]+\*\*|`[^`]+`)/g;
  let last = 0;
  let match;

  while ((match = pattern.exec(text)) !== null) {
    if (match.index > last) {
      parts.push(text.slice(last, match.index));
    }
    const token = match[0];
    if (token.startsWith('**')) {
      parts.push(
        <strong key={`${match.index}-b`} style={{ fontWeight: 600 }}>
          {token.slice(2, -2)}
        </strong>
      );
    } else {
      parts.push(
        <code
          key={`${match.index}-c`}
          style={{
            backgroundColor: theme?.colors?.mono200 ?? '#eee',
            color: theme?.colors?.contentPrimary ?? 'inherit',
            padding: '1px 6px',
            borderRadius: theme?.borders?.radius200 ?? '4px',
            fontSize: '0.88em',
            fontFamily:
              'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
          }}
        >
          {token.slice(1, -1)}
        </code>
      );
    }
    last = match.index + token.length;
  }

  if (last < text.length) {
    parts.push(text.slice(last));
  }

  return parts.length ? parts : text;
}
